import {Button, EmptyState, useDisclosure, VStack} from '@chakra-ui/react'
import {Parts, UI} from 'components'
import useUser from "hooks/useUser";
import useOptions from "hooks/useOptions";

export default function Request() {
    const dialog = useDisclosure();
    const user = useUser();
    const options = useOptions();

    const status = user.data?.consultant?.active_month_status;

    const isDayAvailable = options.data?.isAvailable ?? false;
    const formattedDays = options.data?.rawDays || "--";
    const fixingAmountExternal = 3;
    const minWithdrawAmount = ((options.data?.rawLimitRatedWithdrawalMin / 100) + fixingAmountExternal ).toFixed(2) || "--";

    const canRequestWithdraw = isDayAvailable && status === 1;

    return (
        <>
            <UI.Box>
                <EmptyState.Root size="sm">
                    <EmptyState.Content>
                        <EmptyState.Indicator>
                            <UI.Icon name="withdraw" />
                        </EmptyState.Indicator>
                        <VStack gap={0} textAlign="center">
                            <EmptyState.Title children="Nenhum pedido de saque" />

                            <EmptyState.Description fontSize="xs">
                                Saques podem ser solicitados nos dias <strong>{formattedDays}</strong>
                                {" "} de cada mês com o valor mínimo de R$ {minWithdrawAmount}.
                            </EmptyState.Description>

                            <Button
                                mt={4}
                                variant="outline"
                                onClick={dialog.onOpen}
                                // Desabilita se não puder solicitar ou se estiver carregando
                                disabled={!canRequestWithdraw || user.isLoading || options.isLoading}
                                loading={user.isLoading || options.isLoading}
                            >
                                <UI.Icon name="withdraw" /> Solicitar saque
                            </Button>
                        </VStack>
                    </EmptyState.Content>
                </EmptyState.Root>
            </UI.Box>

            <Parts.Dialog.Withdraws.Request {...dialog} />
        </>
    );
}